import { render, staticRenderFns } from "./smartAction.vue?vue&type=template&id=47007b48&scoped=true"
import script from "./smartAction.vue?vue&type=script&lang=js"
export * from "./smartAction.vue?vue&type=script&lang=js"
import style0 from "./smartAction.vue?vue&type=style&index=0&id=47007b48&prod&scoped=true&lang=css"
import style1 from "./smartAction.vue?vue&type=style&index=1&id=47007b48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47007b48",
  null
  
)

export default component.exports